import { Injectable } from "@angular/core";
import { IFirebaseService } from "./firebase.service.interface";
import { FirebaseX, IChannelOptions } from "@awesome-cordova-plugins/firebase-x/ngx";
import { Observable } from "rxjs";
import { ConfigProvider } from "src/providers/config/config";

@Injectable()
export class FirebaseAndroidService implements IFirebaseService {
    constructor(private firebaseX: FirebaseX, private conf:ConfigProvider) {
        console.log('Firebase Android Service initialized');
    }

    async getToken(): Promise<string> {
        try {            
            const hasPermission = await this.hasPermission();
            if (!hasPermission) {
                console.log('Android: No permission, requesting...');
                const granted = await this.grantPermission();
                
                if (!granted) {
                    throw new Error('Android: User denied notification permissions');
                }
            }  
            await this.createChannel();     
            const token = await this.firebaseX.getToken();
            console.info('Android Firebase token:', token);
            return token;
        } catch (error) {
            console.error('Android token error:', error);
            throw error;
        }
    }

    onMessageReceived(): Observable<any> {
        return this.firebaseX.onMessageReceived();
    }

    onTokenRefresh(): Observable<string> {
        return this.firebaseX.onTokenRefresh();
    }

    async grantPermission(): Promise<boolean> {
        try {
            console.log('Android: Requesting notification permissions...');
            const granted = await this.firebaseX.grantPermission();
            
            if (granted) {
                console.log('Android: Notification permissions granted');
            } else {
                console.warn('Android: Notification permissions denied');
            }
            
            return granted;
        } catch (error) {
            console.error('Android: Error requesting permissions:', error);
            return false;
        }
    }

    async hasPermission(): Promise<boolean> {
        try {
            const hasPermission = await this.firebaseX.hasPermission();
            console.log('Android: Has permission:', hasPermission);
            return hasPermission;
        } catch (error) {
            console.error('Android: Error checking permissions:', error);
            return false;
        }
    }
    async createChannel():Promise<void>{
        const channel: IChannelOptions = {
            id: (await this.conf.config).push.senderID,
            name: "General Notifications",
            description: "Notifications for general app updates",
            importance: 4,
            sound: "default",
            vibration: true,
            light: false,
            badge: true,
            visibility: 1,
        };

        this.firebaseX.createChannel(channel)
        .then(() => {
            console.log("Notification channel created");
        }).catch(err => console.error("Channel creation error", err));

    }
}